import { apiResourceUrl } from "@ploy-lib/core";
import { BaseCamelCasedResource } from "./BaseResource";
export class MenuItemResource extends BaseCamelCasedResource {
    constructor() {
        super(...arguments);
        this.menuItemId = 0;
        this.menuItemName = "";
        this.navigateUrl = "";
        this.defaultSubItemLookId = "";
        this.subGroupCssclass = "";
        this.subGroupItemSpacing = 0;
        this.sortOrder = 0;
        this.parentId = 0;
        this.functionId = 0;
        this.autoPostBackOnSelect = false;
        this.description = "";
        this.navigateUrlexternal = "";
        this.icon = "";
        this.pageComponent = "";
    }
    pk() {
        return this.menuItemId.toString() || "";
    }
}
MenuItemResource.urlRoot = apiResourceUrl("menuitems");
export class MenuItemSubResource extends MenuItemResource {
    constructor() {
        super(...arguments);
        this.produtType = 0;
        this.enabled = false;
        this.lookId = "";
        this.type = "";
    }
    pk() {
        return this.menuItemId.toString() || "";
    }
}
MenuItemSubResource.urlRoot = apiResourceUrl("menuitems/menuSubs");
//# sourceMappingURL=MenuItemResource.js.map